import { useCallback } from 'react';

import { useQuery } from '@tanstack/react-query';
import { apiServiceProxy } from 'v2/services/api-proxy';

const DISMISSED_KEY = 'registryBlockModalDismissedAt';
const DISMISS_DURATION_MS = 24 * 60 * 60 * 1000;

function isDismissed(): boolean {
  try {
    const dismissedAt = localStorage.getItem(DISMISSED_KEY);

    if (!dismissedAt) {
      return false;
    }

    const elapsed = Date.now() - Number(dismissedAt);
    return Number.isFinite(elapsed) && elapsed >= 0 && elapsed < DISMISS_DURATION_MS;
  } catch {
    return false;
  }
}

export function useRegistryCheck() {
  const query = useQuery({
    queryKey: ['registry-check'],
    queryFn: () => apiServiceProxy.get<MyEduzzRegistryCheck>('/registry/check').then(response => response.data)
  });

  const shouldBlock = !!query.data?.block && !isDismissed();

  const dismissBlock = useCallback(() => {
    try {
      localStorage.setItem(DISMISSED_KEY, String(Date.now()));
    } catch {}
  }, []);

  return { ...query, shouldBlock, dismissBlock };
}
